import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: '2.4rem',
      marginBottom: '0.6rem',

      '& .MuiSubtitle1-root': {
        color: '#1A1C19',
      },
    },
    tooltipContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.8rem',
      color: '#727970',

      '& .MuiSvgIcon-root': {
        fontSize: '2rem',
      },

      '& .MuiSubtitle2-root': {
        fontSize: '1.1rem',
        lineHeight: '0',
      },
    },
    tooltip: {
      backgroundColor: '#505356',
      color: '#FFFFFF',
      maxWidth: '70rem',
      fontSize: '1rem',
      padding: '0.4rem 0.8rem',
      border: 'none',
      borderRadius: 5,
      marginLeft: '.4rem',
    },
    arrow: {
      color: '#505356',
    },
    button: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: 0,
      borderColor: '#727970',

      '&:not(:disabled):hover': {
        borderColor: '#727970',
      },

      '& .MuiTouchRipple-root': {
        color: '#727970',
      },
    },
  }),
)
